/* eslint-disable @typescript-eslint/no-explicit-any */
interface IAppBridge {
  sendMessageToApp(method: string, data?: unknown): void;
  sendMessageToAppWithReturn(method: string, data: unknown): Promise<unknown>;
}

export const AppBridge: IAppBridge = {
  sendMessageToApp(method: string, data?: unknown): void {
    const message = { data };
    // iOS Communication
    if (window.webkit?.messageHandlers[method]) {
      window.webkit.messageHandlers[method].postMessage(
        JSON.stringify(message)
      );
    }
    // Android Communication
    else if (window.Android && typeof window.Android[method] === 'function') {
      window.Android[method]();
    }
  },

  sendMessageToAppWithReturn(method: string, data: unknown): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const message = { data };
      if (window.webkit?.messageHandlers[method]) {
        window.webkit.messageHandlers[method].postMessage(
          JSON.stringify(message)
        );
        (window as any)[`${method}Callback`] = resolve;
      } else if (
        window.Android &&
        typeof window.Android[method] === 'function'
      ) {
        const result = window.Android[method](JSON.stringify(message));
        resolve(result);
      } else {
        reject(new Error('Method not available'));
      }
    });
  }
};
